import * as React from 'react';
import { Link } from 'react-router-dom';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import * as ReqType from '../../../types/ServerRequests';

/**
 * interface Props (le parametre de la classe)
 */
interface Props {
    /**
     * user: l'utilisateur courant
     */
    user: ReqType.UserView;
    /**
     * addCallback: l'action après l'ajout d'un user dans la liste des participant
     * @param {UserView} user
     * @returns {Promise<void>}
     */
    addCallback: (user: ReqType.UserView) => Promise<void>;
    /**
     * select: structure de presence
     */
    select?: boolean;
}

/**
 * interface State (l'état interne de la classe LineUserEvent)
 */
interface State {
}

export class LineUserEvent extends React.Component {
    /** le state: l'etat interne */
    state: State;
    /** le props: l'etat externe */
    props: Props;

    /**
     * construit une ligne d'utilisateur du tableau liste des utilisateurs
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
    }

    /**
     * le rendu de la classe LineUserEvent
     * @returns {JSX.Element}
     */
    render() {
        return (
            <tr key={this.props.user.id}>
                <td scope="col">
                    <img
                        src={require('../../ProfilePage/internalComponents/photoProfile.PNG')}
                        className="img-thumbnail mx-auto d-block rounded-circle border-danger"
                        alt="Photo de profil"
                        height="80px"
                        width="80px"
                    />
                </td>
                <td scope="row">
                    <strong>
                        {this.props.user.userProfile === null ? '' : this.props.user.userProfile.nom}
                    </strong>
                </td>
                <td scope="row">{this.props.user.userProfile === null ? '' : this.props.user.userProfile.prenom}</td>
                <td scope="row">{this.props.user.username}</td>
                <td scope="row">{this.props.user.email}</td>
                <td>
                    <Link to={'/userlist/' + this.props.user.id}>
                        <button className="btn btn-default">
                            <i className="fas fa-eye" />
                        </button>
                    </Link>
                </td>
                <td>
                    {this.AddOrDelete()}
                </td>
            </tr>);
    }

    /**
     * l'ajout de l'utilisateur courant dans la liste des présences
     * @returns {JSX.Element}
     * @constructor
     */
    private AddOrDelete(): JSX.Element {
        return (
            <LoaderButton
                className="btn badge-success "
                disabled={this.props.select}
                onClick={
                    () => {
                        return (this.props.addCallback(this.props.user));
                    }
                }
                confirmation={true}
                modalTitle="Ajout de participant"
                modalBody={
                    (
                        <div>
                            Etes vous certain de vouloir ajouter
                                <strong>{' ' + this.props.user.username + ' '}</strong>
                            à l'évènement
                            </div>
                    )}
            >
                <i className="fas fa-plus" />
            </LoaderButton>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/EventPage/internalComponents/LineUserEvent.tsx